// Agrupación del menú principal del módulo de Crédito (idmodulo 9).
//
// El endpoint MenuUsuarios/AccesosMenus regresa los accesos PLANOS ({ titulo, ruta }) y ya
// filtrados por los permisos del usuario, pero sin ninguna categoría. Este arreglo es el que
// decide en qué tarjeta cae cada acceso.
//
// Para dar de alta un acceso nuevo basta con agregar su ruta al grupo que le corresponda; si la
// ruta no aparece en ninguno, MenuModulo lo coloca solo en el grupo "Otros accesos", así que un
// menú nuevo del backend nunca se pierde.
//
// - clave: identificador interno del grupo (no se muestra).
// - icono: llave del catálogo de iconos (MenuModuloIconos.js).
// - color: llave del color del grupo (ver _MenuModulo.scss).
// - accesos: rutas del grupo, en el orden en que se quieren mostrar.
// - etiqueta: nombre que se muestra. El API regresa los títulos en MAYÚSCULAS y sin acentos; esta
//   llave es opcional y solo sirve para presentarlos legibles. Si se omite, se usa tal cual el
//   título que mande el API.
//
// Creado: 2026-09-17 — IA (Claude)
// Actualizado: 2026-09-17 — IA (Claude): se eliminó el grupo "Tasas e Intereses" (sus accesos
// pasaron a "Configuración"), "Buró y Conciliación" se volvió "Buró y Cobranza Jurídica" y se
// agregó "Revisión y Auditoría" con las diferencias y validaciones de proceso.
export const GRUPOS_MENU_CREDITO = [
  {
    clave: "solicitudes",
    titulo: "Solicitudes y Operación",
    descripcion: "Ciclo de otorgamiento",
    icono: "solicitudes",
    color: "verde",
    accesos: [
      { ruta: "/Credito/PCSolicitudes", icono: "panel", etiqueta: "Panel de control de solicitudes" },
      { ruta: "/Credito/PrestamoClientes", icono: "prestamo", etiqueta: "Préstamo a clientes" },
      { ruta: "/Credito/ReestructurarCredito", icono: "reestructura", etiqueta: "Reestructurar crédito" },
      { ruta: "/Credito/RelacionDocumentosSC", icono: "documento", etiqueta: "Relación de documentos SC" },
      { ruta: "/Credito/CumplimientoCompromisosCredito", icono: "cumplimiento", etiqueta: "Cumplimiento de compromisos" },
    ],
  },
  {
    clave: "cartera",
    titulo: "Cartera y Clientes",
    descripcion: "Seguimiento y recuperación",
    icono: "cartera",
    color: "acero",
    accesos: [
      { ruta: "/Credito/CarteraClientes", icono: "clientes", etiqueta: "Cartera de clientes" },
      { ruta: "/Credito/CarteraTransito", icono: "transito", etiqueta: "Cartera en tránsito" },
      { ruta: "/Credito/ClientesEspeciales", icono: "cliente-especial", etiqueta: "Clientes especiales" },
    ],
  },
  {
    clave: "facturacion",
    titulo: "Facturación y Pagarés",
    descripcion: "Comprobantes de crédito",
    icono: "facturacion",
    color: "azul",
    accesos: [
      { ruta: "/Credito/listadoequiposfacturar", icono: "equipo", etiqueta: "Facturar equipo" },
      { ruta: "/Credito/ListadoFacturarCreditoOtorgado", icono: "factura", etiqueta: "Facturar crédito otorgado" },
      { ruta: "/Credito/ListadoRefacturacion", icono: "refactura", etiqueta: "Refacturación de crédito" },
      { ruta: "/Credito/listadopagares", icono: "pagare", etiqueta: "Pagarés" },
    ],
  },
  {
    clave: "buro",
    titulo: "Buró y Cobranza Jurídica",
    descripcion: "Reporte de buró y recuperación legal",
    icono: "buro",
    color: "rojo",
    accesos: [
      { ruta: "/Credito/ReporteBuroCredito", icono: "buro", etiqueta: "Reporte de buró de crédito" },
      { ruta: "/Credito/GestionClientesJuridico", icono: "juridico", etiqueta: "Enviar clientes a jurídico" },
      { ruta: "/Credito/CobranzaJuridico", icono: "juzgado", etiqueta: "Seguimiento cobranza judicial" },
    ],
  },
  {
    clave: "revision",
    titulo: "Revisión y Auditoría",
    descripcion: "Validación de procesos",
    icono: "revision",
    color: "ambar",
    accesos: [
      { ruta: "/Credito/OperacionesNoEncontradasEquip", icono: "documento-buscar", etiqueta: "Documento no encontrado en EQUIP" },
      { ruta: "/Credito/FacturasNoRegistradasEquip", icono: "base-datos", etiqueta: "Documento no encontrado en HD" },
      { ruta: "/Credito/ClientesnoRegistrados", icono: "cliente-nuevo", etiqueta: "Clientes no registrados en HD" },
      { ruta: "/Credito/FacturasnoContempladas", icono: "diferencias", etiqueta: "Diferencias en contrato JDF" },
      { ruta: "/Credito/DiferenciasVencimiento", icono: "diferencia-fecha", etiqueta: "Diferencias en fecha de vencimiento" },
      { ruta: "/Credito/Operacionestasa0", icono: "tasa-cero", etiqueta: "Operaciones tasa 0" },
    ],
  },
  {
    clave: "configuracion",
    titulo: "Configuración",
    descripcion: "Parámetros y catálogos",
    icono: "configuracion",
    color: "neutro",
    accesos: [
      { ruta: "/Credito/Documentos", icono: "carpeta", etiqueta: "Documentos" },
      { ruta: "/Credito/Intereses", icono: "porcentaje", etiqueta: "Interés mensual" },
      { ruta: "/Credito/Intereses2", icono: "porcentaje", etiqueta: "Interés mensual JDF" },
    ],
  },
];

export default GRUPOS_MENU_CREDITO;
